import { render, staticRenderFns } from "./ReadingList.vue?vue&type=template&id=763cd7dc&scoped=true"
import script from "./ReadingList.vue?vue&type=script&lang=js"
export * from "./ReadingList.vue?vue&type=script&lang=js"
import style0 from "./ReadingList.vue?vue&type=style&index=0&id=763cd7dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763cd7dc",
  null
  
)

export default component.exports